import  PartnersElement from './PartnersElement';
export default PartnersElement
